<template>
  <div class="integrations">
    <sticky-header :title="$t('integrations.title')" />

    <message type="warning">
      <strong>{{ $t('integrations.warning') }}</strong> {{ $t('integrations.dontShareAPIKey') }}
    </message>

    <block class="key-areas">
      <div
        slot="content"
        class="key-area key-area-id">
        <strong>{{ $t('integrations.pluginID') }}</strong> {{ $store.state.config.company.bookero_id }}
        <btn
          :type="bookeroIdCopiedText ? 'small' : 'small with-icon'"
          :iconName="bookeroIdCopiedText ? '' : 'layers-thin'"
          @click.native="copyText($store.state.config.company.bookero_id, 'bookeroId')">
          <template v-if="bookeroIdCopiedText">{{ $t('common.ui.copied') }}</template>
          <template v-if="!bookeroIdCopiedText">{{ $t('common.ui.copy') }}</template>
        </btn>
      </div>

      <div
        slot="content"
        class="key-area key-area-key">
        <strong>{{ $t('integrations.apiKey') }}</strong>  {{ $store.state.config.company.api_key }}
        <btn
        :type="apiKeyCopiedText ? 'small' : 'small with-icon'"
        :iconName="apiKeyCopiedText ? '' : 'layers-thin'"
        @click.native="copyText($store.state.config.company.api_key, 'apiKey')">
          <template v-if="apiKeyCopiedText">{{ $t('common.ui.copied') }}</template>
          <template v-if="!apiKeyCopiedText">{{ $t('common.ui.copy') }}</template>
        </btn>
      </div>
    </block>

    <block>
      <div
        slot="content"
        class="box-desc">
        <div class="box-desc-image">
          <img :src="require('./../../assets/img/integrations/comp-1.png')" />
        </div>

        <div class="box-desc-text">
          <div>
            <h2>{{ $t('integrations.inlineBoxTitle') }}</h2>
            <p v-pure-html="$t('integrations.inlineBoxDesc1')"></p>
            <pre>&lt;div id="bookero"&gt;&lt;/div&gt;</pre>
            <p v-pure-html="$t('integrations.inlineBoxDesc2')"></p>
            <p v-pure-html="$t('integrations.inlineBoxDesc3')"></p>
            <pre>plugin_css: false;</pre>
          </div>
        </div>

        <div class="box-desc-download">
          <btn
            type="small"
            @click.native="showPopup('inline-box')">
            {{ $t('integrations.downloadIntegrationCode') }}
          </btn>
        </div>
      </div>
    </block>

    <block>
      <div
        slot="content"
        class="box-desc">
        <div class="box-desc-image">
          <img :src="require('./../../assets/img/integrations/comp-2.png')" />
        </div>

        <div class="box-desc-text">
          <div>
            <h2>{{ $t('integrations.stickyBoxTitle') }}</h2>
            <p v-pure-html="$t('integrations.stickyBoxDesc1')"></p>
            <p v-pure-html="$t('integrations.stickyBoxDesc2')"></p>
            <p v-pure-html="$t('integrations.stickyBoxDesc3')"></p>
            <p v-pure-html="$t('integrations.stickyBoxDesc4')"></p>
            <pre>plugin_css: false;</pre>
          </div>
        </div>

        <div class="box-desc-download">
          <btn
            type="small"
            @click.native="showPopup('sticky-box')">
            {{ $t('integrations.downloadIntegrationCode') }}
          </btn>
        </div>
      </div>
    </block>

    <block>
      <div
        slot="content"
        class="box-desc">
        <div class="box-desc-image">
          <img :src="require('./../../assets/img/integrations/comp-3.png')" />
        </div>

        <div class="box-desc-text">
          <div>
            <h2>{{ $t('integrations.weeklyBoxTitle') }}</h2>
            <p v-pure-html="$t('integrations.weeklyBoxDesc1')"></p>
            <pre>&lt;div id="bookero"&gt;&lt;/div&gt;</pre>
            <p v-pure-html="$t('integrations.weeklyBoxDesc2')"></p>
            <p v-pure-html="$t('integrations.weeklyBoxDesc3')"></p>
            <pre>plugin_css: false;</pre>
          </div>
        </div>

        <div class="box-desc-download">
          <btn
            type="small"
            @click.native="showPopup('weekly-box')">
            {{ $t('integrations.downloadIntegrationCode') }}
          </btn>
        </div>
      </div>
    </block>

    <block>
      <div
        slot="content"
        class="box-desc">
        <div class="box-desc-image">
          <img :src="require('./../../assets/img/integrations/comp-4.png')" />
        </div>

        <div class="box-desc-text">
          <div>
            <h2>{{ $t('integrations.monthlyBoxTitle') }}</h2>
            <p v-pure-html="$t('integrations.monthlyBoxDesc1')"></p>
            <pre>&lt;div id="bookero"&gt;&lt;/div&gt;</pre>
            <p v-pure-html="$t('integrations.monthlyBoxDesc2')"></p>
            <p v-pure-html="$t('integrations.monthlyBoxDesc3')"></p>
            <pre>plugin_css: false;</pre>
          </div>
        </div>

        <div class="box-desc-download">
          <btn
            type="small"
            @click.native="showPopup('monthly-box')">
            {{ $t('integrations.downloadIntegrationCode') }}
          </btn>
        </div>
      </div>
    </block>

    <block>
      <div
        slot="content"
        class="box-desc">
        <div class="box-desc-image">
          <img :src="require('./../../assets/img/integrations/comp-5.png')" />
        </div>

        <div class="box-desc-text">
          <div>
            <h2>{{ $t('integrations.joomlaTitle') }}</h2>
            <p v-pure-html="$t('integrations.joomlaDesc1')"></p>
            <p v-pure-html="$t('integrations.joomlaDesc2')">Pobierz plik instalacyjny i wgraj go do systemu przy pomocy instalatora rozszerzeń. Przejdź do listy dodatków i opublikuj plugin Bookero.</p>
            <p>{{ $t('integrations.joomlaDesc3') }}<code>{{ $store.state.config.company.bookero_id }}</code></p>
          </div>
        </div>

        <div class="box-desc-download">
          <btn
            url="https://bookero.pl/download/joomla/v11/bookero-joomla.zip"
            type="small">
            {{ $t('integrations.downloadInstallationFile') }}
          </btn>
        </div>
      </div>
    </block>

    <block>
      <div
        slot="content"
        class="box-desc">
        <div class="box-desc-image">
          <img :src="require('./../../assets/img/integrations/comp-6.png')" />
        </div>

        <div class="box-desc-text">
          <div>
            <h2>{{ $t('integrations.wpTitle') }}</h2>
            <p v-pure-html="$t('integrations.wpDesc1')"></p>
            <p v-pure-html="$t('integrations.wpDesc2')"></p>
            <p>{{ $t('integrations.wpDesc3') }} <code>{{ $store.state.config.company.api_key }}</code></p>
          </div>
        </div>

        <div class="box-desc-download">
          <btn
            url="https://wordpress.org/plugins/bookeropl/"
            type="small">
            {{ $t('integrations.downloadInstallationFile') }}
          </btn>
        </div>
      </div>
    </block>

    <block
      v-if="fbIntegrationIsActive"
      :title="$t('integrations.fbTitle')">
      <message
        v-if="!websiteIsActive"
        slot="content"
        type="error">
        <strong>{{ $t('integrations.warning') }}</strong> {{ $t('integrations.fbDesc1') }} <btn url="/settings/" type="small inline">{{ $t('integrations.fbDescBtn') }}</btn> {{ $t('integrations.fbDesc2') }}
      </message>

      <div
        class="fb-integration"
        slot="content">
        <p class="fb-intro-text">
          {{ $t('integrations.fbIntroText') }}
        </p>

        <btn
          v-if="!showFbIntegrationInfoDesc"
          type="blue"
          @click.native.prevent="showFbIntegrationInfoDesc = true">
          {{ $t('integrations.fbIntroDescBtn') }}
        </btn>

        <btn
          v-if="showFbIntegrationInfoDesc"
          type="blue"
          @click.native.prevent="showFbIntegrationInfoDesc = false">
          {{ $t('integrations.fbIntroDescBtnClose') }}
        </btn>

        <div
          v-if="showFbIntegrationInfoDesc"
          class="fb-info">
          <p>{{ $t('integrations.fbIntroTitle') }}</p>
          <ol>
            <li>
              {{ $t('integrations.fbIntroDesc1') }}
              <img :src="require('./../../assets/img/integrations/fb-tutorial-1-' + $config.uiLanguage + '.png')" class="fb-info-desc-img" />
            </li>
            <li>
              {{ $t('integrations.fbIntroDesc2') }}
              <img :src="require('./../../assets/img/integrations/fb-tutorial-2-' + $config.uiLanguage + '.png')" class="fb-info-desc-img" />
            </li>
            <li>
              {{ $t('integrations.fbIntroDesc3') }}
              <img :src="require('./../../assets/img/integrations/fb-tutorial-3-' + $config.uiLanguage + '.png')" class="fb-info-desc-img" />
            </li>
            <li>
              {{ $t('integrations.fbIntroDesc4') }}
              <img :src="require('./../../assets/img/integrations/fb-tutorial-4-' + $config.uiLanguage + '.png')" class="fb-info-desc-img" />
            </li>
            <li>
              {{ $t('integrations.fbIntroDesc5') }}
              <img :src="require('./../../assets/img/integrations/fb-tutorial-5-' + $config.uiLanguage + '.png')" class="fb-info-desc-img" />
            </li>
            <li>
              {{ $t('integrations.fbIntroDesc6') }}
            </li>
          </ol>
        </div>
      </div>
    </block>

    <block :title="$t('integrations.webWaveTitle')">
      <div
        slot="content"
        class="steps">
        <figure class="step">
          <img
            :src="require('./../../assets/img/integrations/webwave-1.png')"
            class="step-image" />
          <figcaption class="step-desc">
            <h3>{{ $t('integrations.webWaveStep1Title') }}</h3>
            <p v-pure-html="$t('integrations.webWaveStep1Desc')"></p>
          </figcaption>
        </figure>

        <figure class="step">
          <img
            :src="require('./../../assets/img/integrations/webwave-2.png')"
            class="step-image" />
          <figcaption class="step-desc">
            <h3>{{ $t('integrations.webWaveStep2Title') }}</h3>
            <p v-pure-html="$t('integrations.webWaveStep2Desc')"></p>
          </figcaption>
        </figure>

        <figure class="step">
          <img
            :src="require('./../../assets/img/integrations/webwave-3.png')"
            class="step-image" />
          <figcaption class="step-desc">
            <h3>{{ $t('integrations.webWaveStep3Title') }}</h3>
            <p v-pure-html="$t('integrations.webWaveStep3Desc')"></p>
          </figcaption>
        </figure>

        <figure class="step">
          <img
            :src="require('./../../assets/img/integrations/webwave-4.png')"
            class="step-image" />
          <figcaption class="step-desc">
            <h3>{{ $t('integrations.webWaveStep4Title') }}</h3>
            <p v-pure-html="$t('integrations.webWaveStep4Desc')"></p>
          </figcaption>
        </figure>
      </div>
    </block>

    <integration-popup />
  </div>
</template>

<script>
import AppConfig from './../../env.js';
import Copy from 'copy-to-clipboard';
import Block from './../common/Block';
import IntegrationPopup from './../ui/IntegrationPopup';
import StickyHeader from './../common/StickyHeader';

export default {
  name: 'integrations',
  components: {
    'block': Block,
    'integration-popup': IntegrationPopup,
    'sticky-header': StickyHeader
  },
  computed: {
    fbIntegrationIsActive () {
      return AppConfig.fbIntegrationEnabled;
    },
    hasWebsite () {
      return this.$store.state.config.company.my_page === 1;
    },
    websiteDomain () {
      return this.$store.state.config.company.subdomain + this.$t('settingsWww.websiteDomain');
    },
    websiteIsActive () {
      return !!this.$store.state.config.company.my_page && this.$store.state.config.company.subdomain !== '';
    }
  },
  data () {
    return {
      apiKeyCopiedText: false,
      bookeroIdCopiedText: false,
      showFbIntegrationInfoDesc: false
    };
  },
  methods: {
    copyText (text, btnID) {
      Copy(text);
      this[btnID + 'CopiedText'] = true;

      setTimeout(() => {
        this[btnID + 'CopiedText'] = false;
      }, 2000);
    },
    showPopup (type) {
      type += '-v2';
      this.$bus.$emit('integration-popup-display', type);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.integrations {
  padding: 0 0 2rem 0;
  width: 100%;

  .message {
    margin-top: 2rem;
  }

  .key-areas {
    .block-content {
      display: flex;
      justify-content: space-between;
    }
  }

  .block {
    .message {
      margin: -1rem 0 3rem 0;
    }
  }

  .key-area {
    border-radius: $border-radius-small;
    display: flex;
    margin: -1rem 0;
    padding: 3rem 3rem 2.5rem 3rem;
    width: 49%;

    strong {
      margin-right: .5rem;
    }

    .button {
      margin-left: auto;
      margin-top: -.25rem;
    }

    &-id {
      background: #E9F5FE;
    }

    &-key {
      background: #F4F1FC;
    }
  }

  .box-desc {
    display: flex;
    justify-content: space-between;
    width: 100%;

    &-image {
      align-items: center;
      display: flex;
      min-width: 250px;
    }

    &-text {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      padding: 0 3.6rem;
      width: 100%;

      pre {
        background: $color-bg-light;
        font-size: 1.4rem;
        padding: 1rem 1.5rem;
      }

      code {
        color: $color-notice;
        font-size: 1.4rem;
      }
    }

    &-download {
      align-items: center;
      border-left: 1px solid $color-border;
      display: flex;
      padding: 0 0 0 3.6rem;
      min-width: 200px;
    }
  }

  .steps {
    display: flex;
    justify-content: space-between;

    .step {
      margin: 0;
      position: relative;
      width: 23%;

      &:after {
        border: 4px solid $color-bg-medium;
        border-bottom: none;
        border-left: none;
        content: "";
        height: 15px;
        position: absolute;
        right: -2.5rem;
        top: 33.333333%;
        transform: translateY(-50%) rotate(45deg);
        width: 15px;
      }

      &:last-child:after {
        display: none;
      }

      img {
        display: block;
        margin: 0 auto;
      }

      figcaption {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        h3 {
          font-weight: normal;
          margin: 2rem 0 0 0;
        }

        p {
          font-size: 1.4rem;
          text-align: center;
        }
      }
    }
  }

  .fb-integration {
    margin-top: -1rem;
    width: 100%;
  }

  .fb-intro-text {
    margin-top: 0;
    margin-bottom: 2.4rem;
  }

  .fb-info {
    background: $color-bg-light;
    border-radius: 5px;
    font-size: 20px;
    margin: 2rem 0;
    padding: 1.5rem 2rem;
    width: 100%;

    p {
      font-weight: bold;
      margin: 2rem 0 1rem 0;
    }

    ol {
      margin: 0 0 2rem 0;
      padding-left: 2rem;

      li {
        padding: .5rem 0;
      }
    }

    .fb-info-desc-img {
      border: 3px solid $color-border;
      border-radius: 10px;
      display: block;
      height: auto;
      margin: 4rem 0;
      max-width: 480px;
    }
  }
}

@media (max-width: 1240px) {
  .integrations {
    .key-area {
      flex-wrap: wrap;
      margin-bottom: 0;
      margin-top: 0;

      .button {
        justify-content: center;
        margin-top: 1rem;
        width: 100%;
      }
    }

    .steps {
      .step {
        img {
          max-width: 100%;
        }
      }
    }
  }
}

@media (max-width: 1040px) {
  .integrations {
    .key-area {
      width: 100%;

      &:first-child {
        margin-bottom: 1rem;
      }
    }

    .box-desc {
      flex-wrap: wrap;

      .box-desc-image {
        margin: 0 auto;
      }

      .box-desc-download {
        border: none;
        justify-content: center;
        margin: 2rem 0;
        padding: 0;
        width: 100%;
      }
    }

    .steps {
      flex-wrap: wrap;

      .step {
        width: 48%;

        &:nth-child(1),
        &:nth-child(2) {
          margin-bottom: 4rem;
        }

        &:after {
          display: none;
        }

        .step-desc {
          width: 100%;

          p {
            width: 100%;
          }
        }
      }
    }
  }
}

@media (max-width: 640px) {
  .integrations {
    margin-top: 6rem;

    .key-area {
      word-break: break-all;
    }

    .box-desc-text {
      padding: 0;
      white-space: normal;

      code {
        word-break: break-all;
      }

      pre {
        font-size: 1.1rem;
      }
    }

    .steps {
     .step {
        width: 100%;

        &:nth-child(1),
        &:nth-child(2),
        &:nth-child(3) {
          margin-bottom: 4rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/Integrations.vue